import apiCompetition from '@/api/competition'

const state = {
  data: [],
  isLoading: false,
  error: null,
  total: 0,
}

export const mutationTypes = {
  getCompetitionsAthletesListStart:
    '[competition athletes list] Get competitions athletes start',
  getCompetitionsAthletesListSuccess:
    '[competition athletes list] Get competitions athletes success',
  getCompetitionsAthletesListFailure:
    '[competition athletes list] Get competitions athletes failure',
}

export const actionTypes = {
  getCompetitionsAthletesList:
    '[competition athletes list] Get competition athletes list',
}

const mutations = {
  [mutationTypes.getCompetitionsAthletesListStart](state) {
    state.isLoading = true
    state.error = null
  },

  [mutationTypes.getCompetitionsAthletesListSuccess](state, payload) {
    state.total = payload.total
    state.data = payload.data ? payload.data : payload.list
    state.isLoading = false
  },

  [mutationTypes.getCompetitionsAthletesListFailure](state, payload) {
    state.isLoading = false
    state.error = payload
  },
}

const actions = {
  [actionTypes.getCompetitionsAthletesList](context, params) {
    context.commit(mutationTypes.getCompetitionsAthletesListStart)
    return new Promise((resolve) => {
      apiCompetition
        .getCompetitionAthletesList(params)
        .then((response) => {
          context.commit(mutationTypes.getCompetitionsAthletesListSuccess, {
            ...response.data,
          })
          resolve(response.data)
        })
        .catch((error) => {
          context.commit(
            mutationTypes.getCompetitionsAthletesListFailure,
            error
          )
        })
    })
  },
}

export default {
  state,
  mutations,
  actions,
}
